/**
 * Activity 1 Summary page — DataTables + Monarch Density chart.
 *
 * DataTables and Chart.js are loaded as separate vendor scripts (not bundled
 * via Browserify).  Chart data is injected by PHP as window.mlmp_a1_chart.
 */
module.exports = function init_activity1_summary($) {

  // Populate the BB back link placeholder if present.
  const $backlink_el = $('#site-year-summary-backlink');
  if ($backlink_el.length) {
    const back = (window.mlmp_settings || {}).a1_summary_back_link;
    if (back && back.url && back.text) {
      $backlink_el.html('<a href="' + back.url + '" class="mlmp-back-link">&larr; ' + back.text + '</a>');
    } else {
      $backlink_el.hide();
    }
  }

  // ── DataTables ─────────────────────────────────────────────────────────────
  const $table = $('.a1-records-table');
  if ($table.length) {
    // Column indices (0-based): Actions, Date, Type, Plants, live×7, dead×7
    const ACTIONS_COL = 0;

    $table.DataTable({
      paging: false,
      info: false,
      searching: false,
      orderCellsTop: false,
      order: [[1, 'desc']], // default sort: Date descending
      columnDefs: [
        { orderable: false, targets: ACTIONS_COL },
      ],
    });
  }

  // ── Monarch Density chart ───────────────────────────────────────────────────
  const canvas = document.getElementById('a1-monarch-density-chart');
  if (!canvas || typeof Chart === 'undefined' || typeof mlmp_a1_chart === 'undefined') return;

  const chart_data = mlmp_a1_chart;

  // If every data point across all series is null (all records had 0 milkweeds),
  // there is nothing plottable — show a notice instead of an empty chart.
  const has_plottable_data = chart_data.datasets.some(function (s) {
    return s.data.some(function (v) { return v !== null; });
  });
  if (!has_plottable_data) {
    const notice = document.createElement('p');
    notice.className = 'a1-chart-no-data';
    notice.textContent = chart_data.noDataText || 'No density data to display.';
    canvas.parentNode.replaceChild(notice, canvas);
    return;
  }

  // Colors: Egg → 5ths
  const viz = (window.mlmp_settings || {}).viz_colors || {};
  const STAGE_COLORS = [
    viz.blue,   // Egg
    viz.orange, // 1st
    viz.red,    // 2nd
    viz.navy,   // 3rd
    viz.grey,   // 4th
    viz.dark,   // 5th
  ];

  const datasets = chart_data.datasets.map(function (s, i) {
    return {
      label: s.label,
      data: s.data,
      backgroundColor: STAGE_COLORS[i] || viz.muted,
      stack: 'density',
      spanGaps: false,
      maxBarThickness: 120,
    };
  });

  new Chart(canvas, {
    type: 'bar',
    data: {
      labels: chart_data.labels,
      datasets: datasets,
    },
    options: {
      responsive: true,
      maintainAspectRatio: true,
      plugins: {
        title: {
          display: true,
          text: chart_data.year + ' MLMP Monarch Density for ' + chart_data.siteName,
          font: { size: 15, weight: 'bold' },
          color: viz.title,
          padding: { bottom: 16 },
        },
        legend: {
          reverse: false,
        },
        tooltip: {
          callbacks: {
            label: function (ctx) {
              const val = ctx.parsed.y;
              return ctx.dataset.label + ': ' + (val !== null ? val.toFixed(2) : '—');
            },
          },
        },
      },
      scales: {
        x: {
          stacked: true,
          title: {
            display: true,
            text: 'Date Observed',
            color: viz.axisLabel,
          },
          grid: {
            display: false,
          },
        },
        y: {
          stacked: true,
          beginAtZero: true,
          title: {
            display: true,
            text: 'Monarchs / Milkweed',
            color: viz.axisLabel,
          },
          grid: {
            color: viz.grid,
            lineWidth: 1,
          },
          ticks: {
            maxTicksLimit: 6,
          },
        },
      },
    },
  });

};
